/**
 * Width ÷ height for the top navigation logo slot and the branding crop tool.
 * Matches the wide horizontal “brand bar” in the header (~4:1–5:1); 4.25 sits between them.
 */
export const NAV_LOGO_ASPECT = 4.25;
